import { render, staticRenderFns } from "./KSwitch.vue?vue&type=template&id=0a287e68&"
import script from "./KSwitch.vue?vue&type=script&lang=js&"
export * from "./KSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports